import * as React from 'react'
import {ChangeEvent, Component, ReactElement} from 'react'
import {Box, Collapse} from '@mui/material'
import {NatApplicationRepo} from '../../repository/NatApplicationRepo'
import {
    BlockSpacer,
    BlockSpacerSpOnly,
    currentMedia,
    GridContainer,
    GridItem,
} from '../../../../../styledComponents/ResponsiveConvenience'
import {
    FlexContainer,
    FullWidthColumnFlexContainer,
    FullWidthRowFlexContainer,
    LeftColumnFlexContainer,
    LeftRowFlexContainer,
    RightColumnFlexContainer,
} from '../../../../../styledComponents/FlexComponents'
import {
    autoKanaOnUpdate,
    convertToRoomNumberForResident,
    getCurrentYear,
    toFullWidthNumber
} from '../../../../common/util/Natutil'
import {RequestItemError} from '../../../../../network/response/RequestItemError'
import NatCurrentDateTimeRepo from '../../../currentDateTime/repository/NatCurrentDateTimeRepo'
import moment from 'moment'
import {HAVE_OR_NOT, RESIDENCE_STYLE} from '../../../../../CodeMaster'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey,
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import PPDatePickerForResident from '../../../../../components/shared/forms/resident/PPDatePickerForResident'
import {DisplayItemInputTitleNoMargin} from '../../../../../styledComponents/DisplayItem'
import {ApplyButton, ItemHeading, WideWhiteArea} from '../../common/resident/NatResidentApplicationsCommon'
import {NatGetCurrentDateTime} from '../../../currentDateTime/repository/NatGetCurrentDateTime'
import {
    NatAbsenceContactAddress,
    NatContactAddressOnEmergency,
    NatFamilyStructure,
    NatRentAdminContactAddress,
    NatResidentContactAddressOnEmergencyLocationState,
} from '../NatResidentApplicationInterface'
import {Nullable} from '../../../../../app/TypeHelpers'
import styled from 'styled-components'
import EventEmitterExResident from '../../../../../components/shared/pageBaseComponents/EventEmitterExResident'
import NatCondominiumRepo from '../../../condominium/repository/NatCondominiumRepo'
import {NatZipCode} from '../../../condominium/repository/NatZipCode'
import {Messages} from '../../../../../Messages'
import {DefaultStyledButton, UnstyledLinkStyledButton} from '../../../../../styledComponents/Button'
import PPRadioGroupForResident from '../../../../../components/shared/forms/resident/PPRadioGroupForResident'
import {Colors, FontSize, FontWeights} from '../../../../../styledComponents/Constants'
import {AddCircle, Clear} from '@mui/icons-material'
import {HKConstants} from '../../../../../HKConstants'
import PPSelectForResident, {Option} from '../../../../../components/shared/forms/resident/PPSelectForResident'
import {
    NatFamilyStructureRequest,
    NatPutContactAddressOnEmergencyRequest,
} from '../../repository/NatPutContactAddressOnEmergency'
import NatResidentApplicationDetailFormItem from '../../common/resident/NatResidentApplicationDetailFormItem'
import HolidaysRepository from '../../../../../components/HolidaysRepository'
import {AsyncCallFunctionType} from '../../../../../components/shared/hoc/withAsyncCommunication'
import {TransitionGroup} from 'react-transition-group'
import {PPTextFieldForResident} from '../../../../../components/shared/forms/resident/PPTextFieldForResident'
import ErrorMessageAreaWrapper from '../../../../../components/shared/forms/resident/ErrorMessageAreaWrapper'
import {StyledDiv} from '../../../../../styledComponents/StyledTypeDefinitions'
import {Location, NavigateFunction} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applicationRepo: NatApplicationRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    condominiumRepo: NatCondominiumRepo
    holidaysRepo: HolidaysRepository
    navigate: NavigateFunction,
    location: Location<NatResidentContactAddressOnEmergencyLocationState>
    eventEmitter: EventEmitterExResident
    asyncCallFunction: AsyncCallFunctionType

    residenceStyle: Nullable<string>
    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    occupancyDate: Nullable<string>
    contactAddressOnEmergency: Nullable<NatContactAddressOnEmergency>
    absenceContactAddress: Nullable<NatAbsenceContactAddress>
    rentAdminContactAddressFlag: Nullable<string>
    rentAdminContactAddress: Nullable<NatRentAdminContactAddress>
    familyStructureList: Nullable<NatFamilyStructure[]>

    submitButtonLabel: string
    onClickApplyConfirmButton: (request: NatPutContactAddressOnEmergencyRequest) => Promise<void>
}

interface State {
    residenceStyle: string
    applicantFamilyName: string
    applicantFirstName: string
    occupancyDate: string
    contactAddressOnEmergency: NatContactAddressOnEmergency
    absenceContactAddress: NatAbsenceContactAddress
    rentAdminContactAddressFlag: string
    rentAdminContactAddress: NatRentAdminContactAddress
    familyStructureList: FamilyStructure[]

    currentDate: moment.Moment
    holidays: string[]
    yearOptions: Option[]
    monthOptions: Option[]
    dayOptions: Option[]
    clearBirthDateErrorIndexes: Set<number>

    applyButtonDisabled: boolean
    isLoadCompleted: boolean
}

interface FamilyStructure extends NatFamilyStructure {
    key: number
    convertFamilyNameKana: string
    preFamilyNameKana: string
    convertFirstNameKana: string
    preFirstNameKana: string
}

interface Address {
    prefecture: string
    address2: string
    address3: string
}

const MIN_YEAR: number = 1900
const MIN_BIRTHDAY_MONTH: number = 1
const MAX_BIRTHDAY_MONTH: number = 12
const MIN_BIRTHDAY_DAY: number = 1
const MAX_BIRTHDAY_DAY: number = 31

export default class NatResidentContactAddressOnEmergencyForm extends Component<Props, State> {

    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            residenceStyle: '',
            applyButtonDisabled: true,
            applicantFamilyName: '',
            applicantFirstName: '',
            occupancyDate: '',
            contactAddressOnEmergency: {
                familyName: '',
                firstName: '',
                zipCode: '',
                prefecture: '',
                address2: '',
                address3: '',
                buildingRoomNumber: '',
                fixedPhoneNumber: '',
                mobilePhoneNumber: '',
            },
            absenceContactAddress: {
                familyName: '',
                firstName: '',
                zipCode: '',
                prefecture: '',
                address2: '',
                address3: '',
                buildingRoomNumber: '',
                fixedPhoneNumber: '',
                mobilePhoneNumber: '',
            },
            rentAdminContactAddressFlag: '',
            rentAdminContactAddress: {
                name: '',
                zipCode: '',
                prefecture: '',
                address2: '',
                address3: '',
                buildingRoomNumber: '',
                phoneNumber: '',
            },
            familyStructureList: [
                {
                    index: 0,
                    relationship: '世帯主',
                    familyName: '',
                    firstName: '',
                    familyNameKana: '',
                    firstNameKana: '',
                    birthDate: '',
                    birthYear: '',
                    birthMonth: '',
                    birthDay: '',
                    workAddress: {
                        name: '',
                        zipCode: '',
                        prefecture: '',
                        address2: '',
                        address3: '',
                        buildingRoomNumber: '',
                        phoneNumber: '',
                    },
                    key: 0,
                    convertFamilyNameKana: '',
                    preFamilyNameKana: '',
                    convertFirstNameKana: '',
                    preFirstNameKana: '',
                },
            ],
            yearOptions: [],
            monthOptions: [],
            dayOptions: [],
            clearBirthDateErrorIndexes: new Set<number>(),
            currentDate: moment(),
            holidays: [],
            isLoadCompleted: false,
        }

        this.handleChangeOccupancyDateDate = this.handleChangeOccupancyDateDate.bind(this)


        this.handleChangeRentAdminContactAddressFlag =
            this.handleChangeRentAdminContactAddressFlag.bind(this)


        this.handleChangeFamilyStructureText =
            this.handleChangeFamilyStructureText.bind(this)
        this.handleChangeFamilyStructureFamilyName =
            this.handleChangeFamilyStructureFamilyName.bind(this)
        this.handleChangeFamilyStructureFirstName =
            this.handleChangeFamilyStructureFirstName.bind(this)
        this.handleChangeFamilyStructureBirthYear =
            this.handleChangeFamilyStructureBirthYear.bind(this)
        this.handleChangeFamilyStructureBirthMonth =
            this.handleChangeFamilyStructureBirthMonth.bind(this)
        this.handleChangeFamilyStructureBirthDay =
            this.handleChangeFamilyStructureBirthDay.bind(this)

        this.handleChangeText = this.handleChangeText.bind(this)
        this.handleChangeContactAddressOnEmergencyText = this.handleChangeContactAddressOnEmergencyText.bind(this)
        this.handleChangeAbsenceContactAddressText = this.handleChangeAbsenceContactAddressText.bind(this)
        this.handleChangeRentAdminContactAddressText = this.handleChangeRentAdminContactAddressText.bind(this)
        this.handleChangeFamilyStructureWorkAddressText = this.handleChangeFamilyStructureWorkAddressText.bind(this)

        this.onCompositionStartFamilyStructureFamilyName =
            this.onCompositionStartFamilyStructureFamilyName.bind(this)
        this.onCompositionUpdateFamilyStructureFamilyName =
            this.onCompositionUpdateFamilyStructureFamilyName.bind(this)
        this.onCompositionStartFamilyStructureFirstName =
            this.onCompositionStartFamilyStructureFirstName.bind(this)
        this.onCompositionUpdateFamilyStructureFirstName =
            this.onCompositionUpdateFamilyStructureFirstName.bind(this)

        this.onClickAddFamilyButton = this.onClickAddFamilyButton.bind(this)
        this.onClickDeleteFamilyButton = this.onClickDeleteFamilyButton.bind(this)
        this.onClickApplyConfirmButton = this.onClickApplyConfirmButton.bind(this)
        this.getAddressFromZipCode = this.getAddressFromZipCode.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {
            const [currentTimeResponse, holidays] = await Promise.all([
                this.getCurrentDateTime(),
                this.getHoliday(),
            ])

            if (currentTimeResponse && currentTimeResponse.details) {
                const currentYearMonth: number = getCurrentYear(`${currentTimeResponse.details.currentDateTime}+09:00`)

                const yearOptions: Option[] = [{label: '', value: ''}]
                const monthOptions: Option[] = [{label: '', value: ''}]
                const dayOptions: Option[] = [{label: '', value: ''}]

                for (let year: number = currentYearMonth; MIN_YEAR <= year; year--) {
                    yearOptions.push({label: `${year}`, value: `${year}`})
                }
                for (let month: number = MIN_BIRTHDAY_MONTH; month <= MAX_BIRTHDAY_MONTH; month++) {
                    monthOptions.push({
                        label: `${month}`, value: (String(month).length === 1)
                            ? '0' + String(month) : String(month),
                    })
                }
                for (let month: number = MIN_BIRTHDAY_DAY; month <= MAX_BIRTHDAY_DAY; month++) {
                    dayOptions.push({
                        label: `${month}`, value: (String(month).length === 1)
                            ? '0' + String(month) : String(month),
                    })
                }

                this.setState({
                    currentDate: moment(currentTimeResponse.details.currentDateTime),
                    yearOptions: yearOptions,
                    monthOptions: monthOptions,
                    dayOptions: dayOptions,
                })
            }

            const residenceStyle = (this.props.residenceStyle) ?
                this.props.residenceStyle : this.state.residenceStyle
            const applicantFamilyName = (this.props.applicantFamilyName) ?
                this.props.applicantFamilyName : this.state.applicantFamilyName
            const applicantFirstName = (this.props.applicantFirstName) ?
                this.props.applicantFirstName : this.state.applicantFirstName
            const occupancyDate = (this.props.occupancyDate) ?
                this.props.occupancyDate : this.state.occupancyDate
            const contactAddressOnEmergency = (this.props.contactAddressOnEmergency) ?
                this.props.contactAddressOnEmergency : this.state.contactAddressOnEmergency
            const absenceContactAddress = (this.props.absenceContactAddress) ?
                this.props.absenceContactAddress : this.state.absenceContactAddress
            const rentAdminContactAddressFlag = (this.props.rentAdminContactAddressFlag) ?
                this.props.rentAdminContactAddressFlag : this.state.rentAdminContactAddressFlag
            const rentAdminContactAddress = (this.props.rentAdminContactAddress) ?
                this.props.rentAdminContactAddress : this.state.rentAdminContactAddress
            const familyStructureList = (this.props.familyStructureList) ?
                this.props.familyStructureList : this.state.familyStructureList

            const keyAddFamilyStructureList: FamilyStructure[] = familyStructureList.map(family => {
                return {
                    ...family,
                    key: Math.random(),
                    convertFamilyNameKana: '',
                    preFamilyNameKana: '',
                    convertFirstNameKana: '',
                    preFirstNameKana: '',
                }
            })

            this.setState({
                residenceStyle: residenceStyle,
                applicantFamilyName: applicantFamilyName,
                applicantFirstName: applicantFirstName,
                occupancyDate: occupancyDate,
                contactAddressOnEmergency: contactAddressOnEmergency,
                absenceContactAddress: absenceContactAddress,
                rentAdminContactAddressFlag: rentAdminContactAddressFlag,
                rentAdminContactAddress: rentAdminContactAddress,
                familyStructureList: keyAddFamilyStructureList,
                holidays: holidays === null ? [] : holidays,
            }, () => {
                this.updateApplyConfirmButtonDisabled()
            })
        } finally {
            this.setState({isLoadCompleted: true})
            this.props.eventEmitter.closeLoading()
        }
    }

    async getCurrentDateTime(): Promise<Nullable<NatGetCurrentDateTime>> {
        const {currentDateTimeRepo, eventEmitter} = this.props

        return await this.props.asyncCallFunction(
            currentDateTimeRepo.getCurrentDateTime.bind(currentDateTimeRepo),
            async (httpErrorOrNetworkError) => {
                await httpErrorOrNetworkError.broadcast(eventEmitter)
            },
        )
    }

    async getHoliday(): Promise<Nullable<string[]>> {
        const {holidaysRepo, eventEmitter} = this.props

        const minDate: string = HKConstants.CMN.SYC.MIN_HOLIDAY_DATE
        const maxDate: string = HKConstants.CMN.SYC.MAX_HOLIDAY_DATE
        return await this.props.asyncCallFunction(
            holidaysRepo.getHolidays.bind(holidaysRepo, minDate, maxDate),
            async (httpErrorOrNetworkError) => {
                await httpErrorOrNetworkError.broadcast(eventEmitter)
            },
        )
    }

    onCompositionStartFamilyStructureFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        const {familyStructureList} = this.state
        const index = Number(event.currentTarget.dataset.familyindex)
        familyStructureList[index].convertFamilyNameKana = ''
        familyStructureList[index].preFamilyNameKana = familyStructureList[index].familyNameKana ?? ''
        this.setState({familyStructureList: familyStructureList})
    }

    onCompositionUpdateFamilyStructureFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        const {familyStructureList} = this.state
        const index = Number(event.currentTarget.dataset.familyindex)
        autoKanaOnUpdate(event.data, (kana) => {
            familyStructureList[index].convertFamilyNameKana = familyStructureList[index].preFamilyNameKana + kana
            this.setState({familyStructureList: familyStructureList})
        })
    }

    onCompositionStartFamilyStructureFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        const {familyStructureList} = this.state
        const index = Number(event.currentTarget.dataset.familyindex)
        familyStructureList[index].convertFirstNameKana = ''
        familyStructureList[index].preFirstNameKana = familyStructureList[index].firstNameKana ?? ''
        this.setState({familyStructureList: familyStructureList})
    }

    onCompositionUpdateFamilyStructureFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        const {familyStructureList} = this.state
        const index = Number(event.currentTarget.dataset.familyindex)
        autoKanaOnUpdate(event.data, (kana) => {
            familyStructureList[index].convertFirstNameKana = familyStructureList[index].preFirstNameKana + kana
            this.setState({familyStructureList: familyStructureList})
        })
    }

    handleChangeText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name as keyof State
        const value: string = event.target.value
        this.setState({...this.state, [key]: value}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeOccupancyDateDate(date: string): void {
        this.setState({occupancyDate: date}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeContactAddressOnEmergencyText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name.substring(event.target.name.indexOf('.')).slice(1) as keyof State
        const value: string = event.target.value
        this.setState({
            ...this.state, contactAddressOnEmergency: {...this.state.contactAddressOnEmergency, [key]: value},
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeAbsenceContactAddressText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name.substring(event.target.name.indexOf('.')).slice(1) as keyof State
        const value: string = event.target.value
        this.setState({
            ...this.state, absenceContactAddress: {...this.state.absenceContactAddress, [key]: value},
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeRentAdminContactAddressText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name.substring(event.target.name.indexOf('.')).slice(1) as keyof State
        const value: string = event.target.value
        this.setState({
            ...this.state, rentAdminContactAddress: {...this.state.rentAdminContactAddress, [key]: value},
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeRentAdminContactAddressFlag(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({
            rentAdminContactAddressFlag: event.target.value,
            rentAdminContactAddress: {
                name: '',
                zipCode: '',
                prefecture: '',
                address2: '',
                address3: '',
                buildingRoomNumber: '',
                phoneNumber: '',
            },
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeFamilyStructureText(event: ChangeEvent<HTMLInputElement>): void {
        const {familyStructureList} = this.state
        const key = event.target.name.substring(event.target.name.indexOf('.')).slice(1) as keyof State
        const value: string = event.target.value
        const index = Number(event.target.dataset.familyindex)
        const familyStructure = {...familyStructureList[index], ...{[key]: value}}
        familyStructureList[index] = familyStructure

        this.setState({familyStructureList: familyStructureList}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeFamilyStructureWorkAddressText(event: ChangeEvent<HTMLInputElement>): void {
        const {familyStructureList} = this.state
        const key = event.target.name.substring(event.target.name.indexOf('.workAddress')).slice(13) as keyof State
        const value: string = event.target.value
        const index = Number(event.target.dataset.familyindex)
        const familyStructure = {...familyStructureList[index].workAddress, ...{[key]: value}}
        familyStructureList[index].workAddress = familyStructure

        this.setState({familyStructureList: familyStructureList}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeFamilyStructureFamilyName(event: ChangeEvent<HTMLInputElement>): void {
        const {familyStructureList} = this.state
        const index = Number(event.target.dataset.familyindex)
        familyStructureList[index].familyName = event.target.value
        if (familyStructureList[index].familyName) {
            familyStructureList[index].familyNameKana = familyStructureList[index].convertFamilyNameKana
        } else {
            familyStructureList[index].familyNameKana = ''
        }

        this.setState({familyStructureList: familyStructureList}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeFamilyStructureFirstName(event: ChangeEvent<HTMLInputElement>): void {
        const {familyStructureList} = this.state
        const index = Number(event.target.dataset.familyindex)
        familyStructureList[index].firstName = event.target.value
        if (familyStructureList[index].firstName) {
            familyStructureList[index].firstNameKana = familyStructureList[index].convertFirstNameKana
        } else {
            familyStructureList[index].firstNameKana = ''
        }

        this.setState({familyStructureList: familyStructureList}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeFamilyStructureBirthYear(event: React.ChangeEvent<HTMLSelectElement>): void {
        const {familyStructureList, clearBirthDateErrorIndexes} = this.state
        const index = Number(event.target.dataset.familyindex)
        familyStructureList[index].birthYear = event.target.value
        clearBirthDateErrorIndexes.add(index)

        this.setState({familyStructureList: familyStructureList}, () => {
            this.updateApplyConfirmButtonDisabled()
            this.updateBirthDate(index)
        })
    }

    handleChangeFamilyStructureBirthMonth(event: React.ChangeEvent<HTMLSelectElement>): void {
        const {familyStructureList, clearBirthDateErrorIndexes} = this.state
        const index = Number(event.target.dataset.familyindex)
        familyStructureList[index].birthMonth = event.target.value
        clearBirthDateErrorIndexes.add(index)

        this.setState({
            familyStructureList: familyStructureList,
            clearBirthDateErrorIndexes: clearBirthDateErrorIndexes,
        }, () => {
            this.updateApplyConfirmButtonDisabled()
            this.updateBirthDate(index)
        })
    }

    handleChangeFamilyStructureBirthDay(event: React.ChangeEvent<HTMLSelectElement>): void {
        const {familyStructureList, clearBirthDateErrorIndexes} = this.state
        const index = Number(event.target.dataset.familyindex)
        familyStructureList[index].birthDay = event.target.value
        clearBirthDateErrorIndexes.add(index)

        this.setState({familyStructureList: familyStructureList}, () => {
            this.updateApplyConfirmButtonDisabled()
            this.updateBirthDate(index)
        })
    }

    updateBirthDate(index: number): void {
        const {familyStructureList} = this.state

        if (!familyStructureList[index].birthYear
            && !familyStructureList[index].birthMonth
            && !familyStructureList[index].birthDay) {
            familyStructureList[index].birthDate = ''
            this.setState({familyStructureList: familyStructureList})
        } else {
            familyStructureList[index].birthDate = `${familyStructureList[index].birthYear}-${familyStructureList[index].birthMonth}-${familyStructureList[index].birthDay}`
            this.setState({familyStructureList: familyStructureList})
        }
    }

    onClickAddFamilyButton(): void {
        const {familyStructureList} = this.state

        familyStructureList.push(
            {
                index: familyStructureList.length,
                relationship: '',
                familyName: '',
                firstName: '',
                familyNameKana: '',
                firstNameKana: '',
                birthDate: '',
                birthYear: '',
                birthMonth: '',
                birthDay: '',
                workAddress: {
                    name: '',
                    zipCode: '',
                    prefecture: '',
                    address2: '',
                    address3: '',
                    buildingRoomNumber: '',
                    phoneNumber: '',
                },
                key: Math.random(),
                convertFamilyNameKana: '',
                preFamilyNameKana: '',
                convertFirstNameKana: '',
                preFirstNameKana: '',
            },
        )
        this.setState({familyStructureList: familyStructureList}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    onClickDeleteFamilyButton(index: number): void {
        const {familyStructureList} = this.state
        const updatedFamilyStructure: FamilyStructure[] = []

        familyStructureList.map((family) => {
            const tmpFamilyStructure: FamilyStructure = family
            if (family.index !== index) {
                tmpFamilyStructure.index = updatedFamilyStructure.length
                updatedFamilyStructure.push(tmpFamilyStructure)
            }
        })

        this.setState({familyStructureList: updatedFamilyStructure}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    updateApplyConfirmButtonDisabled(): void {
        const {
            residenceStyle, applicantFamilyName, applicantFirstName,
            contactAddressOnEmergency, absenceContactAddress, rentAdminContactAddressFlag, rentAdminContactAddress,
            familyStructureList,
        } = this.state

        let applyButtonDisabled = false

        switch (residenceStyle) {
            case RESIDENCE_STYLE.UNIT_OWNER.value:
                if (!applicantFamilyName || !applicantFirstName ||
                    !absenceContactAddress.familyName || !absenceContactAddress.firstName ||
                    !absenceContactAddress.prefecture || !absenceContactAddress.address2 ||
                    !absenceContactAddress.address3) {
                    applyButtonDisabled = true
                } else {
                    familyStructureList.map(familyStructure => {
                        if (!familyStructure.relationship || !familyStructure.familyName ||
                            !familyStructure.firstName || !familyStructure.familyNameKana ||
                            !familyStructure.firstNameKana) {
                            applyButtonDisabled = true
                        }
                    })
                }
                break
            case RESIDENCE_STYLE.APPROPRIATOR_AND_TENANT.value:
                if (!applicantFamilyName || !applicantFirstName ||
                    !absenceContactAddress.familyName || !absenceContactAddress.firstName ||
                    !absenceContactAddress.prefecture || !absenceContactAddress.address2 ||
                    !absenceContactAddress.address3) {
                    applyButtonDisabled = true
                } else {
                    if (rentAdminContactAddressFlag === HAVE_OR_NOT.HAVE.value &&
                        (!rentAdminContactAddress.name || !rentAdminContactAddress.phoneNumber)) {
                        applyButtonDisabled = true
                    }
                    familyStructureList.map(familyStructure => {
                        if (!familyStructure.relationship || !familyStructure.familyName ||
                            !familyStructure.firstName || !familyStructure.familyNameKana ||
                            !familyStructure.firstNameKana) {
                            applyButtonDisabled = true
                        }
                    })
                }
                break
            case RESIDENCE_STYLE.EXTERNAL_UNIT_OWNER.value:
                if (!applicantFamilyName || !applicantFirstName ||
                    !contactAddressOnEmergency.familyName || !contactAddressOnEmergency.firstName ||
                    !contactAddressOnEmergency.prefecture || !contactAddressOnEmergency.address2 ||
                    !contactAddressOnEmergency.address3 ||
                    !absenceContactAddress.familyName || !absenceContactAddress.firstName ||
                    !absenceContactAddress.prefecture || !absenceContactAddress.address2 ||
                    !absenceContactAddress.address3) {
                    applyButtonDisabled = true
                } else {
                    if (rentAdminContactAddressFlag === HAVE_OR_NOT.HAVE.value &&
                        (!rentAdminContactAddress.name || !rentAdminContactAddress.phoneNumber)) {
                        applyButtonDisabled = true
                    }
                }
                break
        }
        this.setState({applyButtonDisabled: applyButtonDisabled})
    }

    async getAddressFromZipCode(zipCode: string, resultCode: string): Promise<Nullable<Address>> {
        const {condominiumRepo} = this.props
        let address: Nullable<Address> = null
        await this.props.eventEmitter.showLoading()

        try {
            // 桁数不正の場合、単純に結果が取得できないので特に事前チェックは行わない
            const firstPart = zipCode.substr(0, 3)
            const lastPart = zipCode.substr(3, zipCode.length - 1)

            await condominiumRepo.getZipCode(firstPart, lastPart).then(
                zipData => {
                    const zipCodeResponse: NatZipCode = zipData

                    if (zipCodeResponse && zipCodeResponse.data
                        && zipCodeResponse.data[0] && zipCodeResponse.data[0].ja) {
                        address = {
                            prefecture: zipCodeResponse.data[0].ja.prefecture,
                            address2: zipCodeResponse.data[0].ja.address1,
                            address3: zipCodeResponse.data[0].ja.address2,
                        }
                    }

                    if (zipCodeResponse && zipCodeResponse.data
                        && zipCodeResponse.data.length > 1) {
                        const requestItemError = new RequestItemError(
                            'zipCode', Messages.WCONA0002.toString(), 'WCONA0002')
                        this.props.eventEmitter.emit(resultCode, requestItemError)

                    }
                },
            ).catch(
                () => {
                    const requestItemError = new RequestItemError(
                        'zipCode', Messages.ECONA0001.toString(), 'ECONA0001')
                    this.props.eventEmitter.emit(resultCode, requestItemError)
                },
            )
        } finally {
            this.props.eventEmitter.closeLoading()
        }
        return address
    }

    async getContactAddressOnEmergencyFromZipCode(): Promise<void> {
        const contactAddressOnEmergency = this.state.contactAddressOnEmergency

        const address: Nullable<Address> = await this.getAddressFromZipCode(contactAddressOnEmergency.zipCode, 'contactAddressOnEmergency.zipCode')
        if (address) {
            contactAddressOnEmergency.prefecture = address.prefecture
            contactAddressOnEmergency.address2 = address.address2
            contactAddressOnEmergency.address3 = address.address3
        }
        this.setState({contactAddressOnEmergency: contactAddressOnEmergency}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    async getAbsenceContactAddressFromZipCode(): Promise<void> {
        const absenceContactAddress = this.state.absenceContactAddress

        const address: Nullable<Address> = await this.getAddressFromZipCode(absenceContactAddress.zipCode, 'absenceContactAddress.zipCode')
        if (address) {
            absenceContactAddress.prefecture = address.prefecture
            absenceContactAddress.address2 = address.address2
            absenceContactAddress.address3 = address.address3
        }
        this.setState({absenceContactAddress: absenceContactAddress}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    async getRentAdminContactAddressFromZipCode(): Promise<void> {
        const rentAdminContactAddress = this.state.rentAdminContactAddress

        const address: Nullable<Address> = await this.getAddressFromZipCode(rentAdminContactAddress.zipCode, 'rentAdminContactAddress.zipCode')
        if (address) {
            rentAdminContactAddress.prefecture = address.prefecture
            rentAdminContactAddress.address2 = address.address2
            rentAdminContactAddress.address3 = address.address3
        }
        this.setState({rentAdminContactAddress: rentAdminContactAddress}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    async getWorkAddressFromZipCode(key: number): Promise<void> {
        const familyStructureList = this.state.familyStructureList

        const address: Nullable<Address> = await this.getAddressFromZipCode(
            familyStructureList[key].workAddress.zipCode,
            `familyStructureList[${familyStructureList[key].index}].workAddress.zipCode`,
        )
        if (address) {
            familyStructureList[key].workAddress.prefecture = address.prefecture
            familyStructureList[key].workAddress.address2 = address.address2
            familyStructureList[key].workAddress.address3 = address.address3
        }

        this.setState({familyStructureList: familyStructureList}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    async onClickApplyConfirmButton(): Promise<void> {
        const {
            residenceStyle, applicantFamilyName, applicantFirstName,
            contactAddressOnEmergency, absenceContactAddress, familyStructureList,
            rentAdminContactAddress, rentAdminContactAddressFlag, occupancyDate,
        } = this.state

        this.setState({clearBirthDateErrorIndexes: new Set<number>()})

        const familyStructureRequest: NatFamilyStructureRequest[] = familyStructureList.map(family => {
            return {
                index: family.index,
                relationship: family.relationship,
                familyName: family.familyName,
                firstName: family.firstName,
                familyNameKana: family.familyNameKana,
                firstNameKana: family.firstNameKana,
                birthDate: family.birthDate,
                workAddress: family.workAddress,
            }
        })

        let request: Nullable<NatPutContactAddressOnEmergencyRequest> = null

        switch (residenceStyle) {
            case RESIDENCE_STYLE.UNIT_OWNER.value:
                request = {
                    residenceStyle: residenceStyle,
                    applicantFamilyName: applicantFamilyName,
                    applicantFirstName: applicantFirstName,
                    occupancyDate: occupancyDate,
                    contactAddressOnEmergency: {
                        fixedPhoneNumber: contactAddressOnEmergency.fixedPhoneNumber,
                        mobilePhoneNumber: contactAddressOnEmergency.mobilePhoneNumber,
                    },
                    absenceContactAddress: absenceContactAddress,
                    familyStructureList: familyStructureRequest,
                    confirmed: false,
                }
                break
            case RESIDENCE_STYLE.APPROPRIATOR_AND_TENANT.value:
                request = {
                    residenceStyle: residenceStyle,
                    applicantFamilyName: applicantFamilyName,
                    applicantFirstName: applicantFirstName,
                    occupancyDate: occupancyDate,
                    contactAddressOnEmergency: {
                        fixedPhoneNumber: contactAddressOnEmergency.fixedPhoneNumber,
                        mobilePhoneNumber: contactAddressOnEmergency.mobilePhoneNumber,
                    },
                    absenceContactAddress: absenceContactAddress,
                    rentAdminContactAddress: rentAdminContactAddress,
                    rentAdminContactAddressFlag: rentAdminContactAddressFlag,
                    familyStructureList: familyStructureRequest,
                    confirmed: false,
                }
                break
            case RESIDENCE_STYLE.EXTERNAL_UNIT_OWNER.value:
                request = {
                    residenceStyle: residenceStyle,
                    applicantFamilyName: applicantFamilyName,
                    applicantFirstName: applicantFirstName,
                    contactAddressOnEmergency: contactAddressOnEmergency,
                    absenceContactAddress: absenceContactAddress,
                    rentAdminContactAddress: rentAdminContactAddress,
                    rentAdminContactAddressFlag: rentAdminContactAddressFlag,
                    confirmed: false,
                }
                break
        }

        if (!request) {
            return
        }
        await this.props.onClickApplyConfirmButton(request)
    }

    renderApplicantForm(): ReactElement {
        const {applicantFamilyName, applicantFirstName} = this.state

        const applicantRoom = NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
            convertToRoomNumberForResident(
                NatResidentLoginInfoSessionStorageHelper
                    .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER),
            )

        return (
            <>
                <ItemHeading>
                    申請者
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    {applicantRoom}
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'氏名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'applicantFamilyName',
                                        maxLength: 10,
                                        value: applicantFamilyName,
                                        placeholder: '例：素敵',
                                        onChange: this.handleChangeText,
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['applicantFamilyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'applicantFirstName',
                                        maxLength: 10,
                                        placeholder: '例：太郎',
                                        value: applicantFirstName,
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['applicantFirstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderOccupancyDateForm(): ReactElement {
        const {occupancyDate, holidays} = this.state

        return (
            <>
                <ItemHeading>
                    入居年月日
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'引っ越しする年月日'}
                        component={
                            <PPDatePickerForResident
                                date={occupancyDate}
                                onChange={this.handleChangeOccupancyDateDate}
                                holidays={holidays}
                                itemValue={''}
                                eventKeys={['occupancyDate']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'10px'}/>
                    <SmallSizeTextArea>
                        ※すでに入居されている場合は入力不要です。
                    </SmallSizeTextArea>
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderContactAddressOnEmergencyForm(): ReactElement {
        const {residenceStyle, contactAddressOnEmergency} = this.state
        const {
            familyName, firstName, zipCode, prefecture, address2, address3,
            buildingRoomNumber, fixedPhoneNumber, mobilePhoneNumber,
        } = contactAddressOnEmergency

        return (
            <>
                <ItemHeading>
                    緊急時連絡先
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    {residenceStyle === RESIDENCE_STYLE.EXTERNAL_UNIT_OWNER.value &&
                        <>
                            <NatResidentApplicationDetailFormItem
                                title={'氏名'}
                                required
                                component={
                                    <FlexContainer>
                                        <PPTextFieldForResident
                                            inputProps={{
                                                maxLength: 10,
                                                name: 'contactAddressOnEmergency.familyName',
                                                value: familyName,
                                                placeholder: '例：素敵',
                                            }}
                                            onChange={this.handleChangeContactAddressOnEmergencyText}
                                            eventKeys={['contactAddressOnEmergency.familyName']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                        <FlexContainer>
                                            <BlockSpacer width={5}/>
                                        </FlexContainer>
                                        <PPTextFieldForResident
                                            inputProps={{
                                                maxLength: 10,
                                                name: 'contactAddressOnEmergency.firstName',
                                                value: firstName,
                                                placeholder: '例：太郎',
                                            }}
                                            onChange={this.handleChangeContactAddressOnEmergencyText}
                                            eventKeys={['contactAddressOnEmergency.firstName']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </FlexContainer>
                                }
                            />
                            <Box height={'20px'}/>
                            <NatResidentApplicationDetailFormItem
                                title={'郵便番号（ハイフン不要）'}
                                component={
                                    <ErrorMessageAreaWrapper>
                                        <FlexContainer>
                                            <Box flex={2} minWidth={0}>
                                                <PPTextFieldForResident
                                                    inputProps={{
                                                        maxLength: 7,
                                                        name: 'contactAddressOnEmergency.zipCode',
                                                        value: zipCode,
                                                        placeholder: '例：1234567',
                                                    }}
                                                    onChange={this.handleChangeContactAddressOnEmergencyText}
                                                    eventKeys={['contactAddressOnEmergency.zipCode']}
                                                    eventEmitter={this.props.eventEmitter}
                                                />
                                            </Box>
                                            <FlexContainer>
                                                <BlockSpacer width={5}/>
                                            </FlexContainer>
                                            <Box flex={1} maxWidth={'160px'} minWidth={'125px'} maxHeight={'50px'}>
                                                <DefaultStyledButton
                                                    onClick={() => this.getContactAddressOnEmergencyFromZipCode()}>
                                                    住所自動入力
                                                </DefaultStyledButton>
                                            </Box>
                                        </FlexContainer>
                                    </ErrorMessageAreaWrapper>
                                }
                            />
                            <Box height={'20px'}/>
                            <NatResidentApplicationDetailFormItem
                                title={'都道府県'}
                                required
                                component={
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 4,
                                            name: 'contactAddressOnEmergency.prefecture',
                                            value: prefecture,
                                            placeholder: '例：東京都',
                                        }}
                                        onChange={this.handleChangeContactAddressOnEmergencyText}
                                        eventKeys={['contactAddressOnEmergency.prefecture']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                }
                            />
                            <Box height={'20px'}/>
                            <NatResidentApplicationDetailFormItem
                                title={'市区町村'}
                                required
                                component={
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 50,
                                            name: 'contactAddressOnEmergency.address2',
                                            value: address2,
                                            placeholder: '例：港区',
                                        }}
                                        onChange={this.handleChangeContactAddressOnEmergencyText}
                                        eventKeys={['contactAddressOnEmergency.address2']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                }
                            />
                            <Box height={'20px'}/>
                            <NatResidentApplicationDetailFormItem
                                title={'番地'}
                                required
                                component={
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 50,
                                            name: 'contactAddressOnEmergency.address3',
                                            value: address3,
                                            placeholder: '例：芝４－６－６',
                                        }}
                                        onChange={this.handleChangeContactAddressOnEmergencyText}
                                        eventKeys={['contactAddressOnEmergency.address3']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                }
                            />
                            <Box height={'20px'}/>
                            <NatResidentApplicationDetailFormItem
                                title={'建物名・部屋番号'}
                                component={
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 50,
                                            name: 'contactAddressOnEmergency.buildingRoomNumber',
                                            value: buildingRoomNumber,
                                            placeholder: '例：すてきマンション　１０１号室',
                                            onChange: this.handleChangeContactAddressOnEmergencyText,
                                        }}
                                        onChange={this.handleChangeContactAddressOnEmergencyText}
                                        eventKeys={['contactAddressOnEmergency.buildingRoomNumber']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                }
                            />
                            <Box height={'20px'}/>
                        </>
                    }
                    <NatResidentApplicationDetailFormItem
                        title={'固定電話番号（ハイフン不要）'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 11,
                                    name: 'contactAddressOnEmergency.fixedPhoneNumber',
                                    value: fixedPhoneNumber,
                                    placeholder: '例：0312345678',
                                }}
                                onChange={this.handleChangeContactAddressOnEmergencyText}
                                eventKeys={['contactAddressOnEmergency.fixedPhoneNumber']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'携帯電話番号（ハイフン不要）'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 11,
                                    name: 'contactAddressOnEmergency.mobilePhoneNumber',
                                    value: mobilePhoneNumber,
                                    placeholder: '例：08012345678',
                                }}
                                onChange={this.handleChangeContactAddressOnEmergencyText}
                                eventKeys={['contactAddressOnEmergency.mobilePhoneNumber']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderAbsenceContactAddressForm(): ReactElement {
        const {absenceContactAddress} = this.state
        const {
            familyName, firstName, zipCode, prefecture, address2, address3,
            buildingRoomNumber, fixedPhoneNumber, mobilePhoneNumber,
        } = absenceContactAddress

        return (
            <>
                <ItemHeading>
                    上記連絡先不在などの場合の連絡先
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'氏名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 10,
                                        name: 'absenceContactAddress.familyName',
                                        value: familyName,
                                        placeholder: '例：素敵',
                                    }}
                                    onChange={this.handleChangeAbsenceContactAddressText}
                                    eventKeys={['absenceContactAddress.familyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 10,
                                        name: 'absenceContactAddress.firstName',
                                        value: firstName,
                                        placeholder: '例：太郎',
                                    }}
                                    onChange={this.handleChangeAbsenceContactAddressText}
                                    eventKeys={['absenceContactAddress.firstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'郵便番号（ハイフン不要）'}
                        component={
                            <ErrorMessageAreaWrapper>
                                <FlexContainer>
                                    <Box flex={2} minWidth={0}>
                                        <PPTextFieldForResident
                                            inputProps={{
                                                maxLength: 7,
                                                name: 'absenceContactAddress.zipCode',
                                                value: zipCode,
                                                placeholder: '例：1234567',
                                            }}
                                            onChange={this.handleChangeAbsenceContactAddressText}
                                            eventKeys={['absenceContactAddress.zipCode']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </Box>
                                    <FlexContainer>
                                        <BlockSpacer width={5}/>
                                    </FlexContainer>
                                    <Box flex={1} maxWidth={'160px'} minWidth={'125px'} maxHeight={'50px'}>
                                        <DefaultStyledButton
                                            onClick={() => this.getAbsenceContactAddressFromZipCode()}>
                                            住所自動入力
                                        </DefaultStyledButton>
                                    </Box>
                                </FlexContainer>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'都道府県'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 4,
                                    name: 'absenceContactAddress.prefecture',
                                    value: prefecture,
                                    placeholder: '例：東京都',
                                }}
                                onChange={this.handleChangeAbsenceContactAddressText}
                                eventKeys={['absenceContactAddress.prefecture']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'市区町村'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'absenceContactAddress.address2',
                                    value: address2,
                                    placeholder: '例：港区',
                                }}
                                onChange={this.handleChangeAbsenceContactAddressText}
                                eventKeys={['absenceContactAddress.address2']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'番地'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'absenceContactAddress.address3',
                                    value: address3,
                                    placeholder: '例：芝４－６－６',
                                }}
                                onChange={this.handleChangeAbsenceContactAddressText}
                                eventKeys={['absenceContactAddress.address3']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'建物名・部屋番号'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'absenceContactAddress.buildingRoomNumber',
                                    value: buildingRoomNumber,
                                    placeholder: '例：すてきマンション　１０１号室',
                                }}
                                onChange={this.handleChangeAbsenceContactAddressText}
                                eventKeys={['absenceContactAddress.buildingRoomNumber']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'固定電話番号（ハイフン不要）'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 11,
                                    name: 'absenceContactAddress.fixedPhoneNumber',
                                    value: fixedPhoneNumber,
                                    placeholder: '例：0312345678',
                                }}
                                onChange={this.handleChangeAbsenceContactAddressText}
                                eventKeys={['absenceContactAddress.fixedPhoneNumber']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'携帯電話番号（ハイフン不要）'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 11,
                                    name: 'absenceContactAddress.mobilePhoneNumber',
                                    value: mobilePhoneNumber,
                                    placeholder: '例：08012345678',
                                }}
                                onChange={this.handleChangeAbsenceContactAddressText}
                                eventKeys={['absenceContactAddress.mobilePhoneNumber']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderRentAdminContactAddressForm(): ReactElement {
        const {rentAdminContactAddress, rentAdminContactAddressFlag} = this.state
        const {
            name, zipCode, prefecture, address2, address3,
            buildingRoomNumber, phoneNumber,
        } = rentAdminContactAddress

        return (
            <>
                <ItemHeading>
                    賃貸管理者連絡先（仲介業者など）
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    賃貸で仲介業者を利用している場合は”あり”を選択し、仲介業者の連絡先を入力
                    <Box height={'20px'}/>
                    <GridContainer>
                        <GridItem over={12}>
                            <PPRadioGroupForResident
                                data={HAVE_OR_NOT.values().reverse()}
                                selectValue={rentAdminContactAddressFlag}
                                onChange={this.handleChangeRentAdminContactAddressFlag}
                            />
                        </GridItem>
                    </GridContainer>
                    <Box height={'20px'}/>
                    {rentAdminContactAddressFlag === HAVE_OR_NOT.HAVE.value &&
                        <>
                            <NatResidentApplicationDetailFormItem
                                title={'名称'}
                                required
                                component={
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 50,
                                            name: 'rentAdminContactAddress.name',
                                            value: name,
                                            placeholder: '例：株式会社長谷工リアルエステート',
                                        }}
                                        onChange={this.handleChangeRentAdminContactAddressText}
                                        eventKeys={['rentAdminContactAddress.name']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                }
                            />
                            <Box height={'20px'}/>
                            <NatResidentApplicationDetailFormItem
                                title={<span>電話番号<BreakPcOnly/>（ハイフン不要）</span>}
                                required
                                component={
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 11,
                                            name: 'rentAdminContactAddress.phoneNumber',
                                            value: phoneNumber,
                                            placeholder: '例：0312345678',
                                        }}
                                        onChange={this.handleChangeRentAdminContactAddressText}
                                        eventKeys={['rentAdminContactAddress.phoneNumber']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                }
                            />
                            <Box height={'20px'}/>
                            <NatResidentApplicationDetailFormItem
                                title={'郵便番号（ハイフン不要）'}
                                component={
                                    <ErrorMessageAreaWrapper>
                                        <FlexContainer>
                                            <Box flex={2} minWidth={0}>
                                                <PPTextFieldForResident
                                                    inputProps={{
                                                        maxLength: 7,
                                                        name: 'rentAdminContactAddress.zipCode',
                                                        value: zipCode,
                                                        placeholder: '例：1234567',
                                                    }}
                                                    onChange={this.handleChangeRentAdminContactAddressText}
                                                    eventKeys={['rentAdminContactAddress.zipCode']}
                                                    eventEmitter={this.props.eventEmitter}
                                                />
                                            </Box>
                                            <FlexContainer>
                                                <BlockSpacer width={5}/>
                                            </FlexContainer>
                                            <Box flex={1} maxWidth={'160px'} minWidth={'125px'} maxHeight={'50px'}>
                                                <DefaultStyledButton
                                                    onClick={() => this.getRentAdminContactAddressFromZipCode()}>
                                                    住所自動入力
                                                </DefaultStyledButton>
                                            </Box>
                                        </FlexContainer>
                                    </ErrorMessageAreaWrapper>
                                }
                            />
                            <Box height={'20px'}/>
                            <NatResidentApplicationDetailFormItem
                                title={'都道府県'}
                                component={
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 4,
                                            name: 'rentAdminContactAddress.prefecture',
                                            value: prefecture,
                                            placeholder: '例：東京都',
                                        }}
                                        onChange={this.handleChangeRentAdminContactAddressText}
                                        eventKeys={['rentAdminContactAddress.prefecture']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                }
                            />
                            <Box height={'20px'}/>
                            <NatResidentApplicationDetailFormItem
                                title={'市区町村'}
                                component={
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 50,
                                            name: 'rentAdminContactAddress.address2',
                                            value: address2,
                                            placeholder: '例：港区',
                                        }}
                                        onChange={this.handleChangeRentAdminContactAddressText}
                                        eventKeys={['rentAdminContactAddress.address2']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                }
                            />
                            <Box height={'20px'}/>
                            <NatResidentApplicationDetailFormItem
                                title={'番地'}
                                component={
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 50,
                                            name: 'rentAdminContactAddress.address3',
                                            value: address3,
                                            placeholder: '例：芝４－６－６',
                                        }}
                                        onChange={this.handleChangeRentAdminContactAddressText}
                                        eventKeys={['rentAdminContactAddress.address3']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                }
                            />
                            <Box height={'20px'}/>
                            <NatResidentApplicationDetailFormItem
                                title={'建物名・部屋番号'}
                                component={
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 50,
                                            name: 'rentAdminContactAddress.buildingRoomNumber',
                                            value: buildingRoomNumber,
                                            placeholder: '例：長谷工芝二ビル　５F',
                                        }}
                                        onChange={this.handleChangeRentAdminContactAddressText}
                                        eventKeys={['rentAdminContactAddress.buildingRoomNumber']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                }
                            />
                            <Box height={'20px'}/>
                        </>
                    }
                </WideWhiteArea>
            </>
        )
    }

    renderFamilyStructureListForm(): ReactElement {
        const {familyStructureList} = this.state
        return (
            <>
                <ItemHeading>
                    家族構成（10人まで）
                </ItemHeading>
                <FamilyStructureArea>
                    <TransitionGroup>
                        {familyStructureList.map(
                            (family, key) => {
                                return (<Collapse key={family.key}>
                                    <Box>{family.index === 0 ?
                                        <Box height={'15px'}/> : <Box height={'20px'}/>}
                                        {this.renderFamilyStructureForm(key, family)}</Box>
                                </Collapse>)
                            })}
                    </TransitionGroup>
                    {(HKConstants.VRS.PCD.FAMILY_STRUCTURE_ADD_LIMIT > familyStructureList.length)
                        ? <AddButton onClick={this.onClickAddFamilyButton}>
                            <LeftRowFlexContainer>
                                <AddCircle style={circleIconStyle}/>
                                {`家族を追加する`}
                            </LeftRowFlexContainer>
                        </AddButton>
                        : <Box height={'20px'}/>
                    }
                </FamilyStructureArea>
            </>
        )
    }

    renderFamilyStructureForm(
        key: number,
        familyStructureList: NatFamilyStructure,
    ): ReactElement {
        const {
            index, relationship, familyName, firstName,
            familyNameKana, firstNameKana, birthYear, birthMonth, birthDay, workAddress,
        } = familyStructureList

        return (
            <FamilyArea>
                <FamilyItemHeading>
                    <FullWidthRowFlexContainer>
                        <LeftColumnFlexContainer>
                            {`家族${toFullWidthNumber(index + 1)}`}
                        </LeftColumnFlexContainer>
                        {index !== 0 &&
                            <RightColumnFlexContainer>
                                <ClearButton onClick={() => {
                                    this.onClickDeleteFamilyButton(index)
                                }}>
                                    <LeftRowFlexContainer>
                                        <Clear style={clearIconStyle}/>
                                        取消
                                    </LeftRowFlexContainer>
                                </ClearButton>
                            </RightColumnFlexContainer>
                        }
                    </FullWidthRowFlexContainer>
                </FamilyItemHeading>
                <Box p={'0 10px'}>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'続柄'}
                        required
                        component={
                            index === 0 ?
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 15,
                                        name: `familyStructureList[${index}].relationship`,
                                        value: '世帯主',
                                        disabled: true,
                                    }}
                                    data-familyindex={key}
                                    eventKeys={[`familyStructureListList[${index}].relationship`]}
                                    eventEmitter={this.props.eventEmitter}
                                /> : <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 15,
                                        name: `familyStructureList[${index}].relationship`,
                                        value: relationship,
                                    }}
                                    data-familyindex={key}
                                    onChange={this.handleChangeFamilyStructureText}
                                    eventKeys={[`familyStructureList[${index}].relationship`]}
                                    eventEmitter={this.props.eventEmitter}
                                />
                        }
                    />
                    {index !== 0 &&
                        <GridContainer>
                            <GridItem over={3}/>
                            <GridItem over={9}>
                                <RelationShipNode>
                                    例：夫、妻、子など
                                </RelationShipNode>
                            </GridItem>
                        </GridContainer>
                    }
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'氏名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 10,
                                        name: `familyStructureList[${index}].familyName`,
                                        id: `familyStructureList[${index}].familyName`,
                                        value: familyName,
                                        placeholder: '例：素敵',
                                        onInput: this.handleChangeFamilyStructureFamilyName,
                                        onChange: this.handleChangeFamilyStructureFamilyName,
                                        onCompositionStart: this.onCompositionStartFamilyStructureFamilyName,
                                        onCompositionUpdate: this.onCompositionUpdateFamilyStructureFamilyName,
                                    }}
                                    onChange={this.handleChangeFamilyStructureFamilyName}
                                    data-familyindex={key}
                                    eventKeys={[`familyStructureList[${index}].familyName`]}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 10,
                                        name: `familyStructureList[${index}].firstName`,
                                        id: `familyStructureList[${index}].firstName`,
                                        value: firstName,
                                        placeholder: '例：太郎',
                                        onInput: this.handleChangeFamilyStructureFirstName,
                                        onChange: this.handleChangeFamilyStructureFirstName,
                                        onCompositionStart: this.onCompositionStartFamilyStructureFirstName,
                                        onCompositionUpdate: this.onCompositionUpdateFamilyStructureFirstName,
                                    }}
                                    onChange={this.handleChangeFamilyStructureFirstName}
                                    data-familyindex={key}
                                    eventKeys={[`familyStructureList[${index}].firstName`]}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'氏名カナ'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 20,
                                        name: `familyStructureList[${index}].familyNameKana`,
                                        id: `familyStructureList[${index}].familyNameKana`,
                                        value: familyNameKana,
                                        placeholder: '例：ステキ',
                                    }}
                                    onChange={this.handleChangeFamilyStructureText}
                                    data-familyindex={key}
                                    eventKeys={[`familyStructureList[${key}].familyNameKana`]}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 20,
                                        name: `familyStructureList[${index}].firstNameKana`,
                                        id: `familyStructureList[${index}].firstNameKana`,
                                        value: firstNameKana,
                                        placeholder: '例：タロウ',
                                    }}
                                    onChange={this.handleChangeFamilyStructureText}
                                    data-familyindex={key}
                                    eventKeys={[`familyStructureList[${index}].firstNameKana`]}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'生年月日'}
                        component={
                            <ErrorMessageAreaWrapper>
                                <FlexContainer>
                                    <Box width={'33%'} minWidth={0}>
                                        <PPSelectForResident
                                            inputProps={{
                                                value: birthYear,
                                            }}
                                            placeholder={'年'}
                                            onChange={this.handleChangeFamilyStructureBirthYear}
                                            data-familyindex={key}
                                            options={this.state.yearOptions}
                                            eventKeys={[`familyStructureList[${index}].birthDate`]}
                                            eventEmitter={this.props.eventEmitter}
                                            clearError={this.state.clearBirthDateErrorIndexes.has(key)}
                                        />
                                    </Box>
                                    <FlexContainer>
                                        <BlockSpacer width={8}/>
                                    </FlexContainer>
                                    <Box width={'33%'}>
                                        <PPSelectForResident
                                            inputProps={{
                                                value: birthMonth,
                                            }}
                                            placeholder={'月'}
                                            onChange={this.handleChangeFamilyStructureBirthMonth}
                                            data-familyindex={key}
                                            options={this.state.monthOptions}
                                            eventKeys={[`familyStructureList[${index}].birthDate`]}
                                            eventEmitter={this.props.eventEmitter}
                                            messageInvisible
                                            clearError={this.state.clearBirthDateErrorIndexes.has(key)}
                                        />
                                    </Box>
                                    <FlexContainer>
                                        <BlockSpacer width={8}/>
                                    </FlexContainer>
                                    <Box width={'33%'}>
                                        <PPSelectForResident
                                            inputProps={{
                                                value: birthDay,
                                            }}
                                            placeholder={'日'}
                                            onChange={this.handleChangeFamilyStructureBirthDay}
                                            data-familyindex={key}
                                            options={this.state.dayOptions}
                                            eventKeys={[`familyStructureList[${index}].birthDate`]}
                                            eventEmitter={this.props.eventEmitter}
                                            messageInvisible
                                            clearError={this.state.clearBirthDateErrorIndexes.has(key)}
                                        />
                                    </Box>
                                </FlexContainer>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'勤務先'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: `familyStructureList[${index}].workAddress.name`,
                                    value: workAddress.name,
                                    placeholder: '例：株式会社長谷工コミュニティ',
                                }}
                                onChange={this.handleChangeFamilyStructureWorkAddressText}
                                data-familyindex={key}
                                eventKeys={[`familyStructureList[${index}].workAddress.name`]}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <GridContainer>
                        <GridItem over={3}>
                            <DisplayItemInputTitleNoMargin>
                                勤務先住所
                            </DisplayItemInputTitleNoMargin>
                        </GridItem>
                        <GridItem over={9}>
                            <BlockSpacerSpOnly height={'5px'}/>
                        </GridItem>
                    </GridContainer>
                    <NatResidentApplicationDetailFormItem
                        title={'郵便番号（ハイフン不要）'}
                        component={
                            <ErrorMessageAreaWrapper>
                                <FlexContainer>
                                    <Box flex={2} minWidth={0}>
                                        <PPTextFieldForResident
                                            inputProps={{
                                                maxLength: 7,
                                                name: `familyStructureList[${index}].workAddress.zipCode`,
                                                value: workAddress.zipCode,
                                                placeholder: '例：1234567',
                                            }}
                                            onChange={this.handleChangeFamilyStructureWorkAddressText}
                                            data-familyindex={key}
                                            eventKeys={[`familyStructureList[${index}].workAddress.zipCode`]}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </Box>
                                    <FlexContainer>
                                        <BlockSpacer width={5}/>
                                    </FlexContainer>
                                    <Box flex={1} maxWidth={'160px'} minWidth={'125px'}
                                         maxHeight={'50px'}>
                                        <DefaultStyledButton
                                            onClick={() => this.getWorkAddressFromZipCode(index)}>
                                            住所自動入力
                                        </DefaultStyledButton>
                                    </Box>
                                </FlexContainer>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'都道府県'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 4,
                                    name: `familyStructureList[${index}].workAddress.prefecture`,
                                    value: workAddress.prefecture,
                                    placeholder: '例：東京都',
                                }}
                                onChange={this.handleChangeFamilyStructureWorkAddressText}
                                data-familyindex={key}
                                eventKeys={[`familyStructureList[${index}].workAddress.prefecture`]}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'市区町村'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: `familyStructureList[${index}].workAddress.address2`,
                                    value: workAddress.address2,
                                    placeholder: '例：港区',
                                }}
                                onChange={this.handleChangeFamilyStructureWorkAddressText}
                                data-familyindex={key}
                                eventKeys={[`familyStructureList[${index}].workAddress.address2`]}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'番地'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: `familyStructureList[${index}].workAddress.address3`,
                                    value: workAddress.address3,
                                    placeholder: '例：芝４－６－６',
                                }}
                                onChange={this.handleChangeFamilyStructureWorkAddressText}
                                data-familyindex={key}
                                eventKeys={[`familyStructureList[${index}].workAddress.address3`]}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'建物名・部屋番号'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: `familyStructureList[${index}].workAddress.buildingRoomNumber`,
                                    value: workAddress.buildingRoomNumber,
                                    placeholder: '例：長谷工芝二ビル　５F',
                                }}
                                onChange={this.handleChangeFamilyStructureWorkAddressText}
                                data-familyindex={key}
                                eventKeys={[`familyStructureList[${index}].workAddress.buildingRoomNumber`]}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={<span>勤務先電話番号<BreakPcOnly/>（ハイフン不要）</span>}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 11,
                                    name: `familyStructureList[${index}].workAddress.phoneNumber`,
                                    value: workAddress.phoneNumber,
                                    placeholder: '例：0312345678',
                                }}
                                onChange={this.handleChangeFamilyStructureWorkAddressText}
                                data-familyindex={key}
                                eventKeys={[`familyStructureList[${index}].workAddress.phoneNumber`]}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </Box>
            </FamilyArea>
        )
    }

    render(): ReactElement {
        const {submitButtonLabel} = this.props
        const {residenceStyle, applyButtonDisabled} = this.state

        if (!this.state.isLoadCompleted) {
            return (<></>)
        }

        return (
            <>
                {this.renderApplicantForm()}
                {(residenceStyle === RESIDENCE_STYLE.UNIT_OWNER.value ||
                        residenceStyle === RESIDENCE_STYLE.APPROPRIATOR_AND_TENANT.value) &&
                    <>
                        < Box height={'15px'}/>
                        {this.renderOccupancyDateForm()}
                    </>
                }
                <Box height={'15px'}/>
                {this.renderContactAddressOnEmergencyForm()}
                <Box height={'15px'}/>
                {this.renderAbsenceContactAddressForm()}
                {(residenceStyle === RESIDENCE_STYLE.UNIT_OWNER.value ||
                        residenceStyle === RESIDENCE_STYLE.APPROPRIATOR_AND_TENANT.value) &&
                    <>
                        < Box height={'15px'}/>
                        {this.renderFamilyStructureListForm()}
                    </>
                }
                {(residenceStyle === RESIDENCE_STYLE.APPROPRIATOR_AND_TENANT.value ||
                        residenceStyle === RESIDENCE_STYLE.EXTERNAL_UNIT_OWNER.value) &&
                    <>
                        <Box height={'15px'}/>
                        {this.renderRentAdminContactAddressForm()}
                    </>
                }
                <ApplyButton disabled={applyButtonDisabled} onClick={this.onClickApplyConfirmButton}>
                    <FullWidthColumnFlexContainer>
                        <div>
                            {submitButtonLabel}
                        </div>
                    </FullWidthColumnFlexContainer>
                </ApplyButton>
            </>
        )
    }
}

const RelationShipNode = styled(FlexContainer)`
  font-size: ${FontSize.Small};
  color: ${Colors.AccentDark};
  margin-top: 5px;
`

const FamilyStructureArea = styled(WideWhiteArea)`
  padding: 0 5px;
`

const FamilyArea = styled.div`
  border: 1px solid rgba(0, 112, 176, 0.5);
`

const FamilyItemHeading = styled.div`
  background-color: ${Colors.LightBlue};
  padding: 10px 15px;
  box-sizing: border-box;
  overflow: hidden;
`

const AddButton = styled(UnstyledLinkStyledButton)`
  padding: 20px 20px 20px 0;
  color: ${Colors.Primary};
  font-weight: ${FontWeights.Bold};
  line-height: 24px;
`

const ClearButton = styled(UnstyledLinkStyledButton)`
  color: ${Colors.Alert};
  line-height: 24px;
`

const circleIconStyle = {
    fontSize: FontSize.Big,
    color: Colors.Primary,
    marginRight: '3px',
}

const clearIconStyle = {
    fontSize: FontSize.Big,
    color: Colors.Alert,
    marginRight: '3px',
}

const BreakPcOnly = styled('br')`
  ${currentMedia.lessThan('sp')`
    display: none;
  `};
`
const SmallSizeTextArea: StyledDiv = styled.div`
  font-size: ${FontSize.Middle};
`
